var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRfIconAppSwitcher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{clip-rule:evenodd;}.cls-2{fill-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-4);}.cls-5{clip-path:url(#clip-path-6);}.cls-6{clip-path:url(#clip-path-8);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-71.73-1650.56h-.76v1.67a1.37,1.37,0,0,1,.73,1.23,1.42,1.42,0,0,1-1.44,1.39,1.41,1.41,0,0,1-1.44-1.39,1.37,1.37,0,0,1,.73-1.23v-1.67h-8.18v1.67a1.37,1.37,0,0,1,.73,1.23,1.41,1.41,0,0,1-1.44,1.39,1.42,1.42,0,0,1-1.44-1.39,1.37,1.37,0,0,1,.73-1.23v-1.67h-.76a3,3,0,0,0-3.39,2.81l-1.91,11.41h23.14l-1.91-11.41C-68.67-1649.68-69.67-1650.56-71.73-1650.56Zm-10.36-1.34h8.18v-1.85c0-5.21-8.18-5.21-8.18,0Zm-2.18,0h.76v-1.85c0-7,11-7,11,0v1.85h.76c2.74,0,4.33,1.34,4.77,3.93l1.94,11.52a1.26,1.26,0,0,1-1.29,1.45H-89.69a1.26,1.26,0,0,1-1.29-1.45L-89-1648C-88.6-1650.56-87-1651.9-84.27-1651.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-616-1357.77a5.25,5.25,0,0,1,5.11,5.24,5.24,5.24,0,0,1-5.11,5.23,5.32,5.32,0,0,1-5.5-5.23A5.33,5.33,0,0,1-616-1357.77Zm-9,11.22,7.47,10.46c.85,1.45,2.18,1.45,3.14,0l7.47-10.46a9.75,9.75,0,0,0,2-6A10.76,10.76,0,0,0-616-1363a10.76,10.76,0,0,0-11,10.47A9.33,9.33,0,0,0-625-1346.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-480.78-1302.21c-3.32-2.74-7.19-2.26-10.07.93L-492-1300l-1.14-1.26c-2.88-3.19-6.75-3.67-10.07-.93-3.12,2.5-3.87,7.13-1,10.11l11.22,11.67a1.3,1.3,0,0,0,1.93,0l11.22-11.67C-476.91-1295.08-477.69-1299.71-480.78-1302.21Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-353.4-1311.61a3.7,3.7,0,0,0,2.63,1.08h5.54a3.65,3.65,0,0,0,2.63-1.08,4.45,4.45,0,0,0,1.29-2.86l1.35-17.34H-356l1.35,17.34A4.61,4.61,0,0,0-353.4-1311.61Zm2.31-24v2.29h6.18v-2.29Zm5.86,26.63h-5.54a5.34,5.34,0,0,1-3.73-1.53,6.13,6.13,0,0,1-1.7-3.82l-1.35-17.46h-2c-.29,0-.42-.1-.42-.42v-.7c0-.28.13-.41.42-.41h7.11v-2.32a1.36,1.36,0,0,1,1.38-1.34h6.21a1.35,1.35,0,0,1,1.35,1.34v2.32h7.11c.32,0,.42.13.42.41v.7c0,.32-.1.42-.42.42h-2l-1.35,17.46a6.23,6.23,0,0,1-1.74,3.82A5.34,5.34,0,0,1-345.23-1309Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons-1px-v2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 5,
    height: 5,
    rx: 0.63
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 2,
    width: 5,
    height: 5,
    rx: 0.63
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 2,
    width: 5,
    height: 5,
    rx: 0.63
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17,
    width: 5,
    height: 5,
    rx: 0.63
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 5,
    height: 5,
    rx: 0.63
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 17,
    width: 5,
    height: 5,
    rx: 0.63
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9.5,
    width: 5,
    height: 5,
    rx: 0.63
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9.5,
    width: 5,
    height: 5,
    rx: 0.63
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 5,
    height: 5,
    rx: 0.63
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfIconAppSwitcher);
export default __webpack_public_path__ + "static/media/rf-icon-app-switcher.86e07de8b088387d816b3baf7cf55528.svg";
export { ForwardRef as ReactComponent };